/* eslint-disable  @typescript-eslint/no-explicit-any */

import { GetterTree, MutationTree } from 'vuex';

export enum Types {
  CLEAR = 'clear',
  SWITCH = 'switch',
  SHOW = 'show',
  HIDE = 'hide',
}

export interface State {
  visible: boolean;
}

export const initialState: State = {
  visible: false,
}

export const getters: GetterTree<State, any> = {
  isVisible: (state) => state.visible,
}

export const mutations: MutationTree<State> = {
  [Types.CLEAR](state: State) {
    state.visible = false
  },
  [Types.SWITCH](state: State, visibility) {
    state.visible = visibility
  },
  [Types.SHOW](state: State) {
    state.visible = true
  },
  [Types.HIDE](state: State) {
    state.visible = false
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
};
